/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Save_As_New_CopyInputs */



/**
* | output |
* | --- |
* | "Save as New Copy" |
*
* @param {Save_As_New_CopyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const save_as_new_copy = /** @type {((inputs?: Save_As_New_CopyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Save_As_New_CopyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistrer comme nouvelle copie")
	if (locale === "de") return /** @type {LocalizedString} */ ("Als neue Kopie speichern")
	if (locale === "it") return /** @type {LocalizedString} */ ("Salva come nuova copia")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сохранить как новую копию")
	if (locale === "es") return /** @type {LocalizedString} */ ("Guardar como nueva copia")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("另存为新副本")
	if (locale === "ja") return /** @type {LocalizedString} */ ("新しいコピーとして保存")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नई प्रति के रूप में सहेजें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Salvar como nova cópia")
	return /** @type {LocalizedString} */ ("Save as New Copy")
});